module.exports = __webpack_public_path__ + "img/gray1.74fa6f78.png";